// Settings — single home for every configuration knob (R14, R15).
//
// Grouped IA (IDENTITY / INTEGRATIONS / DATA / SECURITY), sticky left rail on
// desktop, single-column accordion on mobile. `?section=` deep-links a
// section (e.g. the legacy /menu redirect → `menu`).

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SettingsLayout } from '../components/settings/SettingsLayout';
import type { SectionId } from '../components/settings/SettingsRail';

const searchSchema = z.object({ section: z.string().optional() });

function Settings() {
  const { section } = Route.useSearch();
  return <SettingsLayout initialSection={section as SectionId | undefined} />;
}

export const Route = createFileRoute('/settings')({
  component: Settings,
  validateSearch: searchSchema,
});
